/**
 * Applies/removes readonly mode to a rendered form container in one place.
 *
 * Per farmer-form-engine-frontend skill §8: "Áp readonly ở một chỗ duy nhất (readonly.js quét
 * container sau khi render), không rắc if(status === 'draft') khắp renderer." Called by
 * views/submission-form.js whenever the submission's status is not 'draft'.
 */
export function applyReadonly(container, readonly) {
  container.classList.toggle('is-readonly', readonly);
  container.querySelectorAll('input, select, textarea, button').forEach((el) => {
    // Don't disable the section collapse/expand toggles — readonly should still be
    // browsable, just not editable.
    if (el.classList.contains('form-section-head')) return;
    if (readonly) el.setAttribute('disabled', 'disabled');
    else el.removeAttribute('disabled');
  });
  container.querySelectorAll('.repeat-actions, .action-col, .repeat-instance .danger, .opt-clear').forEach((el) => {
    el.hidden = readonly;
  });
}

/** Renders (or removes) the status banner + "request reopen" button above a readonly form. */
export function renderStatusBanner({ host, status, canReopen, onReopen }) {
  host.innerHTML = '';
  if (status === 'draft') return;
  const labels = {
    submitted: { text: 'Phiếu đã nộp — chỉ đọc.', icon: 'lock', tone: 'info' },
    approved: { text: 'Phiếu đã được duyệt — chỉ đọc.', icon: 'verified', tone: 'ok' },
    rejected: { text: 'Phiếu bị từ chối — chỉ đọc.', icon: 'cancel', tone: 'error' },
  };
  const meta = labels[status] || { text: `Trạng thái: ${status}`, icon: 'info', tone: 'info' };
  const banner = document.createElement('div');
  banner.className = `status-banner tone-${meta.tone}`;
  banner.innerHTML = `<span class="ms">${meta.icon}</span><span>${meta.text}</span>`;
  if (canReopen) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-tonal sm';
    btn.textContent = 'Đề nghị mở lại';
    btn.addEventListener('click', () => onReopen && onReopen());
    banner.appendChild(btn);
  }
  host.appendChild(banner);
}
